import { useCallback, useEffect, useState } from 'react';
import { Measurement, MapView } from '../constructors';
import { ESRI_MEASUREMENTS_LINEAR_UNIT, ESRI_MEASUREMENTS_AREA_UNIT } from '../configurations';

export const useMeasurements = (mapView: MapView | undefined) => {
    const [measurementTool, setMeasurementTool] = useState<Measurement>();
    const [activeTool, setActiveTool] = useState<Measurement['activeTool']>();

    useEffect(() => {
        const measurement = new Measurement();
        measurement.linearUnit = ESRI_MEASUREMENTS_LINEAR_UNIT;
        measurement.areaUnit = ESRI_MEASUREMENTS_AREA_UNIT;

        setMeasurementTool(measurement);
    }, []);

    useEffect(() => {
        if (!measurementTool || !mapView) {
            return;
        }

        measurementTool.view = mapView;
    }, [mapView, measurementTool]);

    const setCurrentTool = useCallback(
        (tool: Measurement['activeTool'] | undefined, clearOnReselect = false) => {
            if (!measurementTool) {
                return;
            }

            if (measurementTool.activeTool === tool || !tool) {
                measurementTool.clear();

                if (clearOnReselect || !tool) {
                    setActiveTool(undefined);
                    return;
                }
            }

            setTimeout(() => {
                measurementTool.activeTool = tool;
                setActiveTool(tool);
            }, 1);
        },
        [measurementTool]
    );

    const measureDistance = useCallback(() => {
        setCurrentTool('distance', true);
    }, [setCurrentTool]);

    const measureArea = useCallback(() => {
        setCurrentTool('area', true);
    }, [setCurrentTool]);

    const clear = useCallback(() => {
        if (!measurementTool || !measurementTool.activeTool) {
            return;
        }

        measurementTool.clear();
        setActiveTool(undefined);
    }, [measurementTool]);

    return {
        activeTool,
        measurementTool,
        measureDistance,
        measureArea,
        clear,
        setCurrentTool,
    };
};
